function processValue(value, elementSize, defaultValue = '0') {
  const targetValue = value || defaultValue;
  const numberValue = parseFloat(targetValue);

  if (targetValue.endsWith('%')) {
    return (elementSize / 100) * numberValue;
  }

  return numberValue;
}

function calculateSizeWithInset(values) {
  const {
    minWidthInset,
    maxWidthInset,
    widthShift,
    minHeightInset,
    maxHeightInset,
    heightShift,
    elementWidth,
    elementHeight,
  } = values;

  const widthInset = Math.max(minWidthInset, Math.min(widthShift, maxWidthInset));
  const heightInset = Math.max(minHeightInset, Math.min(heightShift, maxHeightInset));

  const width = elementWidth + 2 * widthInset;
  const height = elementHeight + 2 * heightInset;

  return {
    width,
    height,
    aspectRatio: parseFloat((width / height).toFixed(4)),
  };
}

const getElementSizes = (element) => {
  const { width, height } = element.getBoundingClientRect();
  const targetDocument = element.ownerDocument;
  const targetWindow = targetDocument.defaultView || targetDocument.parentWindow;
  const computedStyles = targetWindow.getComputedStyle(element);
  const minInsetValue = computedStyles.getPropertyValue(
    '--ws-composite-group-positioning-area-min-inset'
  );
  const maxInsetValue = computedStyles.getPropertyValue(
    '--ws-composite-group-positioning-area-max-inset'
  );
  const shiftValue = computedStyles.getPropertyValue('--ws-composite-group-positioning-area-inset');
  const sizeWithInset = calculateSizeWithInset({
    minWidthInset: processValue(minInsetValue, width, '30px'),
    maxWidthInset: processValue(maxInsetValue, width, '100px'),
    widthShift: processValue(shiftValue, width, '15%'),
    minHeightInset: processValue(minInsetValue, height, '30px'),
    maxHeightInset: processValue(maxInsetValue, height, '100px'),
    heightShift: processValue(shiftValue, height, '15%'),
    elementWidth: width,
    elementHeight: height,
  });

  return {
    elementSize: {
      width,
      height,
      aspectRatio: parseFloat((width / height).toFixed(4)),
    },
    sizeWithInset,
  };
};

export default getElementSizes;
